import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getRegionsPhyto.success: {
            return action.payload;
        }

        case constants.getRegionsPhyto.error: {
            return initialState;
        }

        case constants.getRegionsPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}